import type { JobRole } from '@shared/schemas'
import type { PageProps, QueryDefinition } from '@/core'
import type { JobRolesFormValues } from './form'
import type { JobRolesVariables } from './variables'

// 1. Tupla QueryDefinition
export type JobRolesQueryDefinition = [
  QueryDefinition<'jobRoles', 'query', void, Array<JobRole>>,
]

// 2. Endpoint paths
export const JOB_ROLES_ENDPOINTS = {
  list: ['api', 'registry/job-roles'] as [string, string],
  delete: ['api', 'registry/job-roles'] as [string, string],
  create: ['api', 'registry/job-roles'] as [string, string],
  update: (id: string): [string, string] => ['api', `registry/job-roles/${id}`],
  detail: (id: string): [string, string] => ['api', `registry/job-roles/${id}`],
}

// 3. Query keys
export const JOB_ROLES_KEYS = {
  all: ['job-roles'],
  list: () => JOB_ROLES_KEYS.all.join('/'),
  detail: (id: string) => [...JOB_ROLES_KEYS.all, id].join('/'),
  search: (query: string, limit?: number) =>
    [...JOB_ROLES_KEYS.all, 'search', query, limit].join('/'),
}

// 4. Costante queries
export const jobRolesQueries: NonNullable<
  PageProps<
    JobRolesFormValues,
    JobRolesQueryDefinition,
    JobRolesVariables
  >['queries']
> = [
  {
    key: 'jobRoles',
    type: 'query',
    queryConfig: () => ({
      queryKey: [JOB_ROLES_KEYS.list()],
      endpoint: JOB_ROLES_ENDPOINTS.list,
      enabled: true,
    }),
  },
]
